<div class="modalMain">
<div *ngIf="showEnterDentistInfo" class="modal__description m-b-xs-medium m-b-lg-regular font-xs-regular font-lg-medium-big font-color-gray font-weight-bold">
  Enter the information below to view loan offers through iCreditWorks
</div>
<div class="modal__main">
  <div class="main__leftpart">
    <div class="leftpart__image leftpart__image_big">
        <img [src]="sharedDataService.assetsCdn('images/dent-and-pony.jpg')" alt="" loading="lazy" />
    </div>
  </div>
  <div class="mainRightPartLoan main__rightpart">
    <div class="loader__wrapper" *ngIf="showLoader">
      <div class="loader"></div>
    </div>
    <div style="z-index: 3;" class="rightpart__header rightpart__header_bg-orange header-xs-smaller font-lg-bigger">
      {{ dentistHeader() }}
    </div>
    <div style="z-index: 3;"
      *ngIf="showEnterDentistInfo || showDentistList || showDentistFilters"
      class="rightpart__wrapper border-gray"
    >
    
    <app-invalid-state-popup *ngIf="showNoDentistSelectError" style="z-index: 500; width: 100%" 
    [type]="invalidStateErrorType" [isMobile]="breakpoints.extraSmall"></app-invalid-state-popup>
      <div class="d-flex flex-column h-100 w-100 background-color-light-gray">
        <form [formGroup]="findInputs" [style.display]="showEnterDentistInfo ? 'flex' : 'none'" class="find-dentist-form">
          <div class="find-dentist-form__text font-color-black">
            Find your <span class="font-weight-bold">iCreditWorks-Certified Dentist.</span><br>
            Search by dentist, practice name, or location.
          </div>
          <div class="form__row">
            <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Search by dentist or practice name.</span>
              <input id="dentistName" placeholder="" formControlName="dentistName" />
            </div>
          </div>
          <div class="form__row">
       
       
          <!--  <div id="modal__input_location" [ngClass]="{ invalid: findInputs.controls['location'].invalid && findInputs.controls['location'].touched }" class="modal__input modal__input_location column input-area__inactive"  (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Location</span>
              <input ngx-google-places-autocomplete required [options]="placesOptions" #places="ngx-places" id="location" placeholder="" (input)="enterLocation($event)" formControlName="location" (onAddressChange)="autoCompleteOnChange($event)" />
            </div> -->

            <googlemaps-wrapper (inputItemClickEvent)="inputItemClick($event)" [dentistSelect]="true" controlName="location" (enterLocationChange)="enterLocation($event)" 
            (onAddressChange)="autoCompleteOnChange($event)"  >
           </googlemaps-wrapper>

          </div>
          <!-- <div class="form__row">
            <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Dentist Name</span>
              <input id="dentistName" placeholder="" formControlName="dentistName" />
            </div>
          </div>
          <div class="form__row">
            <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Practice Name</span>
              <input id="practiceName" placeholder="" formControlName="practiceName" />
            </div>
          </div>
          <div class="form__row">
            <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Practice Location</span>
              <input id="practiceLocation" placeholder="" formControlName="practiceLocation" />
            </div>
          </div> -->
          <button
            id="submitBtn"
            class="find-dentist-form__button btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn"
            (click)="findDentist()"
          >
            Find Your Dentist
          </button>
          <div (click)="skipSelectDentist()" style="margin: 0 auto .25em; color: #ea731f; font-weight: 500; cursor: pointer;">Not Now</div>
        </form>
        <div *ngIf="showDentistList" class="find-dentist-form">
          <!-- <div class="find-dentist-form__text font-smaller font-color-black">
            <span class="font-weight-bold">Note:</span> If your dentist is not listed below, you may browse by
            practice name.
          </div> -->
          <div (click)="reEnterData()" style="cursor: pointer;" class="form__row form__row_filter d-flex">
            <div class="modal__input column input-area__active" (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Dentist Name/ Practice Name/ Location</span>
              <input style="cursor: pointer;" [(ngModel)]="filtersInfo" disabled id="addressInput" placeholder=""  />
            </div>
            <!-- <button (click)="openFilters()" class="colorBlueBtn color-blue" type="submit"></button> -->
          </div>
          <div *ngIf="dentist.dentistListdata.data.providers.length" style="color: #111; margin: .5em 0;">Select your <span class="font-weight-bold">iCreditWorks-Certified Dentist.</span><br>
            If your dentist is not displayed simply tap <span class="font-weight-bold">Not Now.</span></div>
          <app-modal-options-dentist-select-cards (selectedDentist)="dentistChoosen($event)" (loadMore)="addNewCards($event)" [dentistListInfo]="dentist.dentistListdata"
          ></app-modal-options-dentist-select-cards>
          <button
          *ngIf="dentist.dentistListdata.data.providers.length"
          id="submitBtn"
          class="find-dentist-form__button find-dentist-form__button_select btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn"
          (click)="postSelectDentist()"
        >
          Select Dentist
        </button>
        <button
          *ngIf="!dentist.dentistListdata.data.providers.length"
          id="submitBtn"
          class="find-dentist-form__button btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn"
          (click)="skipSelectDentist()"
        >
          Continue
        </button>
        <div (click)="skipSelectDentist()" *ngIf="dentist.dentistListdata.data.providers.length" class="find-dentist-form__bottomText">Not Now</div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
<!-- <div class="modal__main">
  <div *ngIf="showSelectedDentistInfo" style="position: relative">
    <div style="position: absolute; width: 100%; height: 100%; z-index: 1"></div>
    <google-map width="22.5em" height="100%" [options]="options" [center]="center"></google-map>
    <div style="position: absolute; z-index: 1; left: calc(50% - 4.75em); top: calc(50% - 2.5em)">
      <img
        style="height: auto; width: 15%; margin: 0 42.5%"
        src="../../../../assets/images/icons/placeholder@3x.webp"
        alt=""
      />
      <div style="background-color: white; padding: 0.25em 0.5em; text-align: center">
        <div class="font-small font-light-black text-truncate font-weight-bold">
          {{ selectedDentistInfo.doctorName }}
        </div>
        <div class="font-small font-light-black text-truncate">
          {{ selectedDentistInfo.practiceName }}
        </div>
        <div class="font-small font-light-black text-truncate">
          {{ selectedDentistInfo.doctorsAddressInfo.address1 }}
        </div>
        <div class="font-small font-light-black text-truncate">
          {{ selectedDentistInfo.doctorsAddressInfo.city }},
          {{ selectedDentistInfo.doctorsAddressInfo.state }},
          {{ selectedDentistInfo.doctorsAddressInfo.zipCode }}
        </div>
      </div>
    </div>
  </div>
  <div
    style="height: 100%"
    *ngIf="showPreApprovedPopup"
    class="mainLeftPartDiv main__leftpart flex-column a-items-center"
  >
    <div style="height: 100%" class="leftPartImageLoanSelect leftpart__image m-b-lg-large">
      <img
        style="width: 100%; min-height: 100%; object-fit: initial"
        src="../../../../assets/images/dentist-and-ponytail-guy-looking-at-ipad-i-stock-941443494@3x.webp"
        alt=""
        loading="lazy"
      />
    </div>
  </div>
  <div
    *ngIf="!showSelectedDentistInfo && !showPreApprovedPopup"
    class="mainLeftPartDiv main__leftpart flex-column a-items-center"
  >
    <div class="leftPartImageLoanSelect leftpart__image m-b-lg-large">
      <img src="../../../assets/images/i-stock-686366942.png')" alt="" loading="lazy" />
    </div>
    <div class="header-xs-small header-lg-big font-color-black m-b-xs-regular m-b-lg-regular">
      Congratulations!
    </div>
    <div
      class="preApprovedText font-xs-medium header-lg-smaller font-color-black column-xs-100 text-align-center m-b-xs-regular m-b-lg-regular"
    >
      Your loan request has been<br />
      <span class="font-weight-bold">pre-approved up to $20,000</span>
    </div>
    <div
      class="whenSelectText font-xs-medium header-lg-smaller font-color-black column-xs-100 text-align-center m-b-xs-regular m-b-lg-regular"
    >
      When you select <br />an <span class="font-weight-bold">iCreditWorks-Certified </span>dentist.
    </div>
    <div class="pleaseNoteLoanSelect font-xs-smaller font-lg-medium text-align-center font-color-dark-gray">
      <span class="font-weight-bold">Note</span>: This pre-approval is
      <span class="font-weight-bold">valid until {{ expiryDate }}</span> and is subject<br />
      to completion of your loan application through iCreditWorks.
    </div>
  </div>
  <div style="position: relative" class="mainRightPartLoan main__rightpart">
    <app-autopay-popup
      *ngIf="showSelectedDentistConfirmation"
      style="z-index: 500"
      [type]="101"
      (closed)="changeDentist()"
      (loadForm)="confirmDentist()"
      class="hover-content"
      [showData]="selectedDentistInfo"
      [maxLoanAmount]="this.dentistData.maxApprovedLoanAmount"
    >
    </app-autopay-popup>
    <app-autopay-popup
      *ngIf="showPreApprovedPopup"
      style="z-index: 500"
      [type]="102"
      (closed)="changeDentist()"
      (loadForm)="approveDentist()"
      (update)="getCertifiedDentistList()"
      class="hover-content"
      [maxLoanAmount]="this.dentistData.inNwMaxApprovedAmount"
      [approvedAmount]="this.dentistData.approvedLoanAmount"
    >
    </app-autopay-popup>
    <div class="rightpart__header rightpart__header_bg-orange header-xs-smaller font-lg-bigger">
      {{ dentistHeader() }}
    </div>
    <div *ngIf="showSelectedDentistInfo" style="align-items: start" class="rightpart__wrapper border-gray">
      <div style="padding: 3.5em 4em 0 4em; width: 100%; height: 100%; display: flex; flex-direction: column">
        <div class="d-flex w-100">
          <div
            class="doctor_avatar"
            [ngClass]="{
              border: selectedDentistInfo?.icwPreferred === true,
              'no-border': selectedDentistInfo?.icwPreferred === false
            }"
            *ngIf="selectedDentistInfo?.imageUrl; else noDoctorImage"
          >
            <img [src]="selectedDentistInfo?.imageUrl')" alt="" loading="lazy" srcset="" />
          </div>
          <ng-template #noDoctorImage>
            <div
              class="doctor_avatar placeholder"
              [ngClass]="{
                border: selectedDentistInfo?.icwPreferred === true,
                border_none: selectedDentistInfo?.icwPreferred === true
              }"
              *ngIf="selectedDentistInfo?.gender == 'M'"
            >
              <img
                *ngIf="selectedDentistInfo?.icwPreferred"
                class="border"
                src="../../../../assets/images/m_icon_preferred.svg"
                alt=""
                loading="lazy"
                srcset=""
              />
              <img
                *ngIf="!selectedDentistInfo?.icwPreferred"
                src="../../../../assets/images/m_icon.svg"
                alt=""
                loading="lazy"
                srcset=""
              />
            </div>
            <div
              class="doctor_avatar placeholder"
              [ngClass]="{
                border: selectedDentistInfo?.icwPreferred === true,
                border_none: selectedDentistInfo?.icwPreferred === true
              }"
              *ngIf="selectedDentistInfo?.gender == 'F'"
            >
              <img
                *ngIf="selectedDentistInfo?.icwPreferred"
                src="../../../../assets/images/f_icon_prederred.svg"
                alt=""
                loading="lazy"
                srcset=""
              />
              <img
                *ngIf="!selectedDentistInfo?.icwPreferred"
                src="../../../../assets/images/f_icon.svg"
                alt=""
                loading="lazy"
                srcset=""
              />
            </div>
            <div
              class="doctor_avatar placeholder"
              [ngClass]="{
                border: selectedDentistInfo?.icwPreferred === true,
                border_none: selectedDentistInfo?.icwPreferred === true
              }"
              *ngIf="selectedDentistInfo?.gender == null || selectedDentistInfo?.gender.length === 0"
            >
              <img
                *ngIf="selectedDentistInfo?.icwPreferred"
                src="../../../../assets/images/doctor-empty_preferred.svg"
                alt=""
                loading="lazy"
                srcset=""
              />
              <img
                *ngIf="!selectedDentistInfo?.icwPreferred"
                src="../../../../assets/images/doctor-empty.svg"
                alt=""
                loading="lazy"
                srcset=""
              />
            </div>
          </ng-template>
          <div class="flex-column text-align-left">
            <div [style.opacity]="selectedDentistInfo.icwPreferred ? 1 : 0" class="font-black">
              <img style="height: 1em" src="../../../../../assets/images/icw-sertified.webp" alt="" />
            </div>
            <div
              style="font-size: 1.2em; line-height: 0.97; margin-bottom: 0.5em; color: #111"
              class="font-black font-weight-bold"
            >
              {{ selectedDentistInfo.doctorName }}
            </div>
            <div class="font-light-black d-flex">
              <img
                style="height: 1.3em; margin-right: 0.5em"
                src="../../../../../assets/images/icons/ico-location@3x.webp"
                alt=""
              />
              <div>
                <div class="font-regular-big font-light-black text-truncate">
                  {{ selectedDentistInfo.practiceName }}
                </div>
                <div class="font-regular-big font-light-black text-truncate">
                  {{ selectedDentistInfo.doctorsAddressInfo.address1 }}
                </div>
                <div>
                  {{ selectedDentistInfo.doctorsAddressInfo.city }},
                  {{ selectedDentistInfo.doctorsAddressInfo.state }},
                  {{ selectedDentistInfo.doctorsAddressInfo.zipCode }}
                </div>
              </div>
            </div>
            <div class="font-light-black d-flex">
              <img
                style="height: 1.3em; margin-right: 0.5em"
                src="../../../../assets/images/icons/ico-call@3x.webp"
                alt=""
              />
              <div style="color: blue; height: 1em; margin: auto auto auto 0">
                {{ selectedDentistInfo.contact | mask: '(000) 000-0000' }}
              </div>
            </div>
          </div>
        </div>
        <div class="dentist__services">
          <div style="text-align: left">Services</div>
          <div class="d-flex">
            <div
              *ngFor="let specItem of selectedDentistInfo.speciality"
              class="doctor-speciality font-smaller font-light-black m-r-small"
            >
              {{ specItem }}
            </div>
          </div>
        </div>
        <button
          (click)="submitDentist()"
          style="margin: auto auto 1em"
          id="submitBtn"
          class="btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn"
        >
          Select Dentist
        </button>
      </div>
    </div>
    <div
      *ngIf="showEnterDentistInfo || showDentistList || showDentistFilters"
      class="rightpart__wrapper border-gray"
    >
      <div
        *ngIf="showEnterDentistInfo || showDentistList"
        class="find-dentist-banner d-flex w-100 background-color-white j-content-center"
      >
        <div class="find-dentist-banner__logo">
          <img [src]="sharedDataService.assetsCdn('images/find-dentist.webp" alt="" />
        </div>
        <div class="find-dentist-banner__text">
          <span class="font-color-black">Only the best for you!</span><br />It’s time to select your dentist.
        </div>
      </div>
      <div class="d-flex flex-column h-100 w-100 background-color-light-gray">
        <form [formGroup]="filterInputs" class="d-flex flex-column h-100" *ngIf="showDentistFilters">
          <div class="filter__item">
            <div style="text-align: start; margin-left: 2.5%">Edison, NJ</div>
            <div class="form__row form__row_small">
              <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)">
                <select
                  style="border: none; height: 100%; font-size: 1em; outline: none"
                  id="stateOptionSmall"
                  formControlName="radius"
                  required
                >
                  <option value=""></option>
                  <option *ngFor="let radiusElem of filtersInfo.miles" [value]="radiusElem.value">
                    {{ radiusElem.key }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="filter__item">
            <div style="text-align: start; margin-left: 2.5%">Services</div>
            <div class="form__row form__row_small">
              <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)">
                <select
                  style="border: none; height: 100%; font-size: 1em; outline: none"
                  id="stateOptionSmall"
                  formControlName="services"
                  required
                >
                  <option value=""></option>
                  <option *ngFor="let serviceElem of filtersInfo.specialities" [value]="serviceElem.name">
                    {{ serviceElem.displayName }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div style="font-size: 0.8em" class="filter__item filter__item_big d-flex">
            <div style="margin: auto auto auto 2.5%; font-size: 1.3em">
              Only iCreditWorks-Certified Dentists
            </div>
            <div style="margin: auto 2.5% auto 0" class="my-auto ml-large">
              <input type="checkbox" id="autopay" name="autopay" formControlName="certified" />
              <label class="ios-checkbox" for="autopay"></label>
            </div>
          </div>
          <button
            (click)="acceptFilters()"
            style="margin: auto auto 1em"
            id="submitBtn"
            class="btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn"
          >
            Search
          </button>
        </form>
        <form [formGroup]="findInputs" *ngIf="showEnterDentistInfo" class="find-dentist-form">
          <div class="find-dentist-form__text font-color-black">
            Search for your dentist by name, practice name, or simply<br />
            enter a location to search iCreditWorks-Certified dentists.
          </div>
          <div class="form__row">
            <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Dentist Name</span>
              <input id="dentistName" placeholder="" formControlName="dentistName" />
            </div>
          </div>
          <div class="form__row">
            <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Practice Name</span>
              <input id="practiceName" placeholder="" formControlName="practiceName" />
            </div>
          </div>
          <div class="form__row">
            <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Practice Location</span>
              <input id="practiceLocation" placeholder="" formControlName="practiceLocation" />
            </div>
          </div>
          <button
            style="margin: auto auto 1em"
            id="submitBtn"
            class="btn btn-size_normal btn-primary font-lg-medium-big CheckOptionsFormBtn"
            (click)="findDentist()"
          >
            Find Your Dentist
          </button>
        </form>
        <div *ngIf="showDentistList" class="find-dentist-form">
          <div class="find-dentist-form__text font-smaller font-color-black">
            <span class="font-weight-bold">Note:</span> If your dentist is not listed below, you may browse by
            practice name.
          </div>
          <div class="form__row form__row_filter d-flex">
            <div class="modal__input column input-area__inactive" (click)="inputItemClick($event)">
              <span class="descBlock font-color-gray">Dentist Name/ Practice Name/ Location</span>
              <input id="addressInput" placeholder="" />
            </div>
            <button (click)="openFilters()" class="colorBlueBtn color-blue" type="submit"></button>
          </div>
          <app-modal-options-dentist-select-cards
            (selectedDentist)="dentistChoosen($event)"
          ></app-modal-options-dentist-select-cards>
        </div>
      </div>
    </div>
  </div>
</div> -->
